import React, { useRef, useState } from "react"
import FaqElement from "./practical-faq-element"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

function PracticalFaqContainer({
  header,
  subHeader,
  faqElements,
  readMoreLabel,
  readLessLabel,
  iconUpload,
  hideIcon,
  backgroundColor,
  bottomPadding,
  topPadding,
}) {
  const topRef = useRef()

  const [showMore, setShowMore] = useState(false)
  const bgColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor, false) || undefined
  const tPadding = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding, false) || undefined
  const bPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding, false) || undefined

  const scrollIntoView = () => {
    let element = topRef.current

    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight + 20
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({ top: offsetPosition, behavior: "smooth" })
  }

  const toggleFaq = () => {
    scrollIntoView()
    setShowMore(!showMore)
  }

  return (
    <div className={`faq-container ${bgColor ? bgColor : "c--misty-grey"} ${tPadding} ${bPadding}`}>
      <div ref={topRef} className={`handling-accordion`}>
        <div className="w--normal">
          {hideIcon ? undefined : iconUpload ? (
            <img className="faq-icon" data-epi-property="IconUpload" src={iconUpload} />
          ) : (
            <div className="faq-icon">
              <svg className="icon faq_3">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-faq_3">
                  &nbsp;
                </use>
              </svg>
            </div>
          )}
          <div className="faq-header-container">
            <p data-epi-property="Header" className="faq-header">
              <strong>{header}</strong> {subHeader}
            </p>
          </div>
          <div className={faqElements.length > 6 ? `faq-elements more-questions ${showMore ? "show-all" : ""}` : "faq-elements"}>
            {faqElements.map((element, index) => {
              return <FaqElement key={index} question={element.question} answer={element.answer} />
            })}
            <div className="show-more-questions">
              <button data-epi-property="ReadMoreLabel" onClick={toggleFaq} className="button button--expander more">
                {readMoreLabel}
              </button>
              <button data-epi-property="ReadLessLabel" onClick={toggleFaq} className="button button--expander less">
                {readLessLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PracticalFaqContainer
